import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=4fa392dc&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"
import style0 from "./index_new.vue?vue&type=style&index=0&id=4fa392dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa392dc",
  null
  
)

export default component.exports